import { LottieAnimation } from 'components/__new/common/LottieAnimation'
import React from 'react'
import { Link } from 'react-router-dom';
import tickLottieData from 'assets/lottie/tick.json';

export const CreditApplicationSubmitted = () => {
    return (
        <div className="flex justify-center items-center">
            <div className="relative bg-[#FFFFFF] h-full px-10 py-10 rounded-3xl">
                <div className='h-24'>
                    <LottieAnimation animationData={tickLottieData} />
                </div>
                <div className="text-2xl font-bold leading-7 text-center mt-8">
                    Credit Request Submitted
                </div>
                
                <div className="font-medium text-[#4A5564] mt-6 mb-2 leading-5 text-center">
                    <p>Thank you for submitting your credit request.</p>
                    <p className='mt-4'>
                        We are currently reviewing your application and will send you an 
                        <br />
                        email with the next steps within the next 48 hours.
                    </p>
                </div>
                
                <div className="text-[#0D0C2B] font-normal leading-5 text-center mt-8 rounded-xl" style={{ backgroundColor: "#00535C0D", border: "0.5px solid #E5E7EB", padding: "18px" }}>
                    For further assistance, please contact support at
                    <br />
                    <a href="mailto:business@earnipay.com" rel="noreferrer" target="_blank" className="text-ep-primary underline">
                        business@earnipay.com
                    </a>
                </div>
            
                <div className="mt-8 flex w-full">
                    <Link to="/dashboard" type="submit" loading={false} className="btn h-[56px] w-full btn-ep-primary font-medium text-lg leading-7">
                        Close
                    </Link>
                </div>
            </div>
        </div>
    )
}
